import { Drawer, DrawerOverlay } from '@chakra-ui/react';
import type { LocaleCode } from '@ifixit/i18n';
import { useState, Suspense, lazy } from 'react';
import { DevicePickerModal } from '@ifixit/device-picker';

interface WorkbenchDrawerProps {
   storeLocale: LocaleCode;
   langid: string;
   indexPrefix: string;
   searchClient: Parameters<typeof DevicePickerModal>[0]['algoliaConfig']['searchClient'] | null;
   isOpen: boolean;
   onClose: () => void;
}

const LazyWorkbenchDrawerContent = lazy(() => import('./workbench-drawer-content'));
const LazyDevicePicker = lazy(() => import('./workbench-device-picker'));

export function WorkbenchDrawer({
   isOpen,
   onClose,
   storeLocale,
   langid,
   indexPrefix,
   searchClient,
}: WorkbenchDrawerProps) {
   const [isDevicePickerOpen, setDevicePickerOpen] = useState(false);

   if (!searchClient) {
      return null;
   }

   return (
      <>
         <Drawer
            isOpen={isOpen && !isDevicePickerOpen}
            placement="right"
            onClose={onClose}
            size="md"
         >
            <DrawerOverlay />
            {isOpen && (
               <Suspense>
                  <LazyWorkbenchDrawerContent
                     setDevicePickerOpen={setDevicePickerOpen}
                     langid={langid}
                  />
               </Suspense>
            )}
         </Drawer>

         {isOpen && (
            <LazyDevicePicker
               isOpen={isDevicePickerOpen}
               setOpen={setDevicePickerOpen}
               storeLocale={storeLocale}
               langid={langid}
               indexPrefix={indexPrefix}
               searchClient={searchClient}
            />
         )}
      </>
   );
}
